import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface CalendarToggleStore {
  isVisible: boolean
  toggle: () => void
  show: () => void
  hide: () => void
}

export const useCalendarToggle = create<CalendarToggleStore>()(
  persist(
    (set) => ({
      isVisible: false,
      toggle: () => set((state) => ({ isVisible: !state.isVisible })),
      show: () => set({ isVisible: true }),
      hide: () => set({ isVisible: false }),
    }),
    {
      name: 'sweetspot:home:calendar-visible',
    },
  ),
)

export const useCalendarIsVisible = () => {
  return useCalendarToggle((state) => state.isVisible)
}
